<template>
    <!--  BEGIN SIDEBAR  -->
    <div class='sidebar-wrapper sidebar-theme'>
        <nav ref='menu' id='sidebar'>
            <div class='shadow-bottom'></div>

            <perfect-scrollbar
                class='list-unstyled menu-categories'
                tag='ul'
                :options='{ wheelSpeed: 0.5, swipeEasing: !0, minScrollbarLength: 40, maxScrollbarLength: 300, suppressScrollX: true }'>

                <li class='menu'>
                    <router-link :to='{name: "portal.home"}' class='dropdown-toggle' @click='toggleMobileMenu'>
                        <div class=''>
                            <font-awesome-icon icon='fa-solid fa-chart-pie' />
                            <span>Dashboard</span>
                        </div>
                    </router-link>
                </li>

                <li class='menu'>
                    <router-link :to='{name: "portal.position-description"}' class='dropdown-toggle'
                                 @click='toggleMobileMenu'>
                        <div class=''>
                            <font-awesome-icon icon='fa-solid fa-comments' />
                            <span>Chat de Descrição</span>
                        </div>
                    </router-link>
                </li>

                <li class='menu' v-can:analyze-description-view-portal>
                    <router-link :to='{name: "portal.approval-description"}' class='dropdown-toggle'
                                 @click='toggleMobileMenu'>
                        <div class=''>
                            <font-awesome-icon icon='fa-solid fa-clipboard' />
                            <span>Descrições</span>
                        </div>
                    </router-link>
                </li>

                <li class='menu' v-if="$can('evaluation-view-portal')">
                    <a class='dropdown-toggle' data-bs-toggle='collapse' data-bs-target='#evaluation'
                       aria-controls='components' aria-expanded='false'>
                        <div class=''>
                            <font-awesome-icon icon='fa-solid fa-chart-bar' />
                            <span>Desempenho</span>
                        </div>
                        <div>
                            <svg
                                xmlns='http://www.w3.org/2000/svg'
                                width='24'
                                height='24'
                                viewBox='0 0 24 24'
                                fill='none'
                                stroke='currentColor'
                                stroke-width='2'
                                stroke-linecap='round'
                                stroke-linejoin='round'
                                class='feather feather-chevron-right'
                            >
                                <polyline points='9 18 15 12 9 6'></polyline>
                            </svg>
                        </div>
                    </a>

                    <ul id='evaluation' class='collapse submenu list-unstyled' data-bs-parent='#sidebar'>
                        <li v-if="$can('evaluation-skill-approval-portal')">
                            <router-link :to='{name: "portal.avaliacoes.questionarios"}' @click='toggleMobileMenu'>
                                Aprovações
                            </router-link>
                        </li>
                        <li v-if="$can('role:manager')">
                            <router-link :to='{name: "portal.report"}' @click='toggleMobileMenu'>
                                Relatório Individual
                            </router-link>
                        </li>
                        <li>
                            <router-link :to='{name: "portal.my-reviews"}' @click='toggleMobileMenu'>
                                Minhas Avaliações
                            </router-link>
                        </li>
                        <li>
                            <router-link :to='{name: "portal.evaluate-colleagues"}' @click='toggleMobileMenu'>
                                Avaliar Colegas
                            </router-link>
                        </li>
                        <li>
                            <router-link :to='{name: "portal.evaluate-teams"}' @click='toggleMobileMenu'>
                                Avaliar Equipe
                            </router-link>
                        </li>
                        <li>
                            <router-link :to='{name: "portal.pdi-collaborator"}' @click='toggleMobileMenu'>
                                Meus PDIs
                            </router-link>
                        </li>
                        <li v-if="$can('role:manager')">
                            <router-link :to='{name: "portal.pdi-manager"}' @click='toggleMobileMenu'>
                                Gerenciar PDIs
                            </router-link>
                        </li>
                    </ul>
                </li>

                <li class='menu' v-if="$can('variable-pay-view-portal') || $can('variable-pay-view-evaluator')">
                    <router-link :to='getVariablePayRoute()' class='dropdown-toggle' @click='toggleMobileMenu'>
                        <div class=''>
                            <font-awesome-icon icon="fa-solid fa-chart-line" />
                            <span>Metas e Indica.</span>
                        </div>
                    </router-link>
                </li>

                <li class='menu'>
                    <a href="https://b24-zvwhn3.bitrix24.com.br/online/ticket" target="_blank" class='dropdown-toggle'>
                        <div class=''>
                            <font-awesome-icon icon='fa-solid fa-life-ring' />
                            <span>Precisa de Ajuda?</span>
                        </div>
                    </a>
                </li>

            </perfect-scrollbar>
        </nav>
    </div>
    <!--  END SIDEBAR  -->
</template>

<script setup>
    import { onMounted } from 'vue';
    import { useStore } from 'vuex';
    import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

    const store = useStore();

    const getVariablePayRoute = () => {
        const permissions = store.getters['user/permissions'];
        if (permissions.includes('variable-pay-view-portal')) {
            return { name: 'portal.variable-pay' };
        }
        return { name: 'portal.variable-pay-collaborators' };
    };

    onMounted(async () => {
        const selector = document.querySelector('#sidebar a[href="' + window.location.pathname + '"]');
        if (selector) {
            const ul = selector.closest('ul.collapse');
            if (ul) {
                let ele = ul.closest('li.menu').querySelectorAll('.dropdown-toggle');
                if (ele) {
                    ele = ele[0];
                    setTimeout(() => {
                        ele.click();
                    });
                }
            } else {
                selector.click();
            }
        }
    });

    const toggleMobileMenu = () => {
        if (window.innerWidth < 991) {
            store.commit('toggleSideBar', !store.state.is_show_sidebar);
        }
    };

    const onClickHelper = () => {
        Typebot.initPopup({
            typebot: 'abertura-ticket',
            apiHost: 'https://typechat.deppes.com',
            autoShowDelay: 50,
            prefilledVariables: {
                name: store.state.user.user?.name,
                client: store.state.user.contract_name,
                email: store.state.user.user?.email,
                user_id: store.state.user.user?.id
            },
            onEnd() {
                setTimeout(() => Typebot.close(), 4000);
            }
        });
    };
</script>
